import { Component, input } from '@angular/core';
import type { OnyxColor } from '../../badges/interfaces';

@Component({
  selector: 'onyx-progress',
  imports: [],
  templateUrl: './onyx-progress.component.html',
  styleUrl: './onyx-progress.component.scss',
})
export class OnyxProgressComponent {
  public readonly value = input(0);
  public readonly max = input(100);
  public readonly color = input<OnyxColor>('blue');
  public readonly disabled = input(false);
}
